/**
 * RecordingApiConfiguration.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


import ArgumentError from '../utils/ArgumentError';
import validatePlugin from '../utils/validatePlugin';


/**
 * Validates plugin list, returns the first invalid plugin.
 * Returns undefined if all plugins are valid.
 *
 * @param {Array.<IPlugin>} plugins List of recorder plugins
 * @return {IPlugin|undefined}
 */
function getInvalidPlugin(plugins) {
    for (const plugin of plugins) {
        if (!validatePlugin(plugin)) {
            return plugin;
        }
    }

    return undefined;
}


export default class RecordingApiConfiguration {
    /**
     * RecordingApiConfiguration constructor.
     *
     * @param {{
     *   plugins: Array.<IPlugin>
     * }} options RecordingApiConfiguration constructor options.
     */
    constructor(options) {
        if (typeof options === 'undefined') {
            throw new ArgumentError('You should pass the options to the constructor');
        }

        if (typeof options.plugins === 'undefined') {
            throw new ArgumentError('You should pass the list of plugins to the constructor');
        }

        if (options.plugins.length === 0) {
            throw new ArgumentError('The list of plugins can not be empty');
        }

        const invalidPlugin = getInvalidPlugin(options.plugins);
        if (invalidPlugin) {
            throw new ArgumentError(`${invalidPlugin} is not a valid plugin object`);
        }

        this.plugins = options.plugins;
    }

    /**
     * Returns the list of registered recorder plugins.
     *
     * @return {Array.<IPlugin>}
     */
    getPlugins() {
        return this.plugins;
    }
}
